<template>
    <div>
        <div id="mygalModal" aria-hidden="true" class="modal fade move-up in intro-modal modal-for-gal" style="display: block;z-index: 9999;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="close-button" @click.prevent="CloseDialog($event)">×</div>
                    <div class="new-modal">
                        <div class="modal_down bacground_sdo">
                            <div class="intro-modal-body">
                                <div class="trial-details">
                                    <div class="preview" style="padding-top: 35px !important;display:flex;justify-content: center;">
                                        <span style="font-size: 20px;">Medication Instruction</span>
                                    </div>
                                    <div class="preview" style="padding-top: 35px !important;display:flex;justify-content: center;" >
                                            <table>
                                                <thead>
                                                    <tr style="border-bottom: 1px solid grey;padding-bottom: 10px;">
                                                        <td>Name</td>
                                                        <td>Directions</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="items in textP" :key="items.rxId" style="border-bottom: 1px solid grey;padding-bottom: 10px;">
                                                        <td>{{ items.name }}</td>
                                                        <td>{{ items.directions }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                    </div>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    export default {
        props: ["textP"],
        data() {
            return {
                mykey: 1,
                
            }
        },
        mounted() {
    
        },
        methods: {
            
            CloseDialog(event) {
                event.preventDefault();
                this.$emit("CloseBox");
            },
        },
        created() {
            
        }
    }
    </script>
    
    <style scoped>
    .modal {
        display: none;
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgb(0, 0, 0);
        background-color: rgba(0, 0, 0, 0.4);
    
    }
    
    .intro-modal-body {
        justify-content: center;
    }
    
    .intro-modal-heading {
        font-size: 18px;
        display: flex;
        justify-content: center;
    }
    
    .modal-content {
        position: relative;
        background-color: #fefefe;
        border-radius: 10px;
        max-width: 468px;
        margin: 15% auto;
        padding: 20px;
        border: 1px solid #888;
        width: 80%;
    }
    
    .dash-button {
        height: 45px;
    }
    
    .options-container {
        display: flex;
        flex-wrap: wrap;
    }
    .close-button {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    color: #888;
    transition: color 0.2s;
}

.close-button:hover {
    color: #000;
}
    </style>
    